import { useT } from "../../shared/i18n";
import { Button, Card } from "../../shared/ui";

const EXAMPLES = [
  {
    id: "expenses",
    name: "intro.expenses.name",
    prompt: "intro.expenses.prompt",
  },
  {
    id: "workouts",
    name: "intro.workouts.name",
    prompt: "intro.workouts.prompt",
  },
  { id: "meters", name: "intro.meters.name", prompt: "intro.meters.prompt" },
] as const;

/**
 * Value proposition shown once to a user with no section. The CTA leads to the
 * assistant chat, where sections are described and built.
 */
export function FirstRunIntro({
  onStart,
  onSkip,
}: {
  onStart: () => void;
  onSkip: () => void;
}) {
  const t = useT();
  return (
    <main
      aria-labelledby="first-run-intro-title"
      className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-4 px-6 py-10"
    >
      <h1 id="first-run-intro-title" className="text-h3 font-bold">
        {t("intro.title")}
      </h1>
      <p className="text-body text-fg-muted">{t("intro.body")}</p>
      <Card title={t("intro.examples")}>
        <ul className="flex flex-col gap-3">
          {EXAMPLES.map((example) => (
            <li key={example.id}>
              <strong className="block text-body">{t(example.name)}</strong>
              <span className="text-body text-fg-muted">
                {t(example.prompt)}
              </span>
            </li>
          ))}
        </ul>
      </Card>
      <div className="flex flex-col gap-3">
        <Button onClick={onStart}>{t("intro.cta")}</Button>
        <Button variant="secondary" onClick={onSkip}>
          {t("intro.skip")}
        </Button>
      </div>
    </main>
  );
}
